import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';

/**
 * Route User Cell Renderer for Routes Territories
 * Displays route and responsible information using UserRouteDisplayComponent
 */
@Component({
  selector: 'app-route-user-cell-renderer',
  standalone: true,
  imports: [CommonModule, UserRouteDisplayComponent],
  template: `
    <app-user-route-display
      class="leading-tight"
      [routeData]="routeData"
      [responsibleData]="responsibleData"
      [displayMode]="'detailed'"
      [showRouteCode]="true"
      [showUser]="false"
      [showResponsible]="true">
    </app-user-route-display>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class RouteUserCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get routeData() {
    const data = this.params?.data;
    if (!data) return { routeName: '-', externalKeys: { code: '-' } };

    return {
      routeName: data.subRouteName ?? '-',
      externalKeys: { code: data.subRouteCode ?? '-' }
    };
  }

  get responsibleData() {
    const data = this.params?.data;
    if (!data) return { name: '-', externalKeys: { code: '-' } };

    return {
      name: data.responsibleName ?? '-',
      externalKeys: { code: data.responsibleCode ?? '-' }
    };
  }
}
